import { isSameDay } from 'date-fns';
import { getCurrentUtcTime } from 'js/lib/DateUtils';
import { TIME_RANGES } from '../constants';

const staticRangeHandler = {
  range: {},
  isSelected(range: { startDate: Date; endDate: Date }) {
    const definedRange = this.range();
    return (
      isSameDay(range.startDate, definedRange.startDate) &&
      isSameDay(range.endDate, definedRange.endDate)
    );
  },
};

export function createStaticRanges(ranges: any[]) {
  return ranges.map((range) => ({ ...staticRangeHandler, ...range }));
}

/**
 * Creates static date ranges for FlowRunLogs component
 * These ranges correspond to the options previously available in LogStartDateSelector
 */
export function createLogDateRanges() {
  const currentTime = getCurrentUtcTime(false).valueOf() as number;
  const currentTimeDate = new Date(currentTime);

  return createStaticRanges([
    {
      label: 'Last 5 minutes',
      range: () => ({
        startDate: new Date(currentTime - TIME_RANGES.FIVE_MINUTES),
        endDate: currentTimeDate,
        key: 'ranges',
        label: 'Last 5 minutes',
      }),
    },
    {
      label: 'Last 15 minutes',
      range: () => ({
        startDate: new Date(currentTime - TIME_RANGES.FIFTEEN_MINUTES),
        endDate: currentTimeDate,
        key: 'ranges',
        label: 'Last 15 minutes',
      }),
    },
    {
      label: 'Last 30 minutes',
      range: () => ({
        startDate: new Date(currentTime - TIME_RANGES.THIRTY_MINUTES),
        endDate: currentTimeDate,
        key: 'ranges',
        label: 'Last 30 minutes',
      }),
    },
    {
      label: 'Last 1 hour',
      range: () => ({
        startDate: new Date(currentTime - TIME_RANGES.ONE_HOUR),
        endDate: currentTimeDate,
        key: 'ranges',
        label: 'Last 1 hour',
      }),
    },
    {
      label: 'Last 3 hours',
      range: () => ({
        startDate: new Date(currentTime - TIME_RANGES.THREE_HOURS),
        endDate: currentTimeDate,
        key: 'ranges',
        label: 'Last 3 hours',
      }),
    },
    {
      label: 'Last 6 hours',
      range: () => ({
        startDate: new Date(currentTime - TIME_RANGES.SIX_HOURS),
        endDate: currentTimeDate,
        key: 'ranges',
        label: 'Last 6 hours',
      }),
    },
    {
      label: 'Last 12 hours',
      range: () => ({
        startDate: new Date(currentTime - TIME_RANGES.TWELVE_HOURS),
        endDate: currentTimeDate,
        key: 'ranges',
        label: 'Last 12 hours',
      }),
    },
    {
      label: 'Last 24 hours',
      range: () => ({
        startDate: new Date(currentTime - TIME_RANGES.TWENTY_FOUR_HOURS),
        endDate: currentTimeDate,
        key: 'ranges',
        label: 'Last 24 hours',
      }),
    },
    {
      label: 'Last 2 days',
      range: () => ({
        startDate: new Date(currentTime - TIME_RANGES.TWO_DAYS),
        endDate: currentTimeDate,
        key: 'ranges',
        label: 'Last 2 days',
      }),
    },
    {
      label: 'Last 3 days',
      range: () => ({
        startDate: new Date(currentTime - TIME_RANGES.THREE_DAYS),
        endDate: currentTimeDate,
        key: 'ranges',
        label: 'Last 3 days (max retention)',
      }),
    },
  ]);
}
